import { queryClient } from '@/adapters/query';
import type { FacilityScreenerSettingsEntry } from '@/types/crm-screener-api';

import { SCREENER_SETTINGS_PER_FACILITY_KEY } from './useFacilityScreenerSettings';

type ScreenerSettingValue = string | number | object;

export const getScreenerSettingValue = <
  T extends ScreenerSettingValue = string
>(
  settingName: string,
  facilityId: string
): T | undefined =>
  queryClient.getQueryData<FacilityScreenerSettingsEntry>([
    SCREENER_SETTINGS_PER_FACILITY_KEY,
    facilityId
  ])?.settings?.[settingName] as T | undefined;

export const isScreenerSettingEnabled = (
  settingName: string,
  facilityId: string
): boolean =>
  getScreenerSettingValue<string>(settingName, facilityId) === 'enabled';
